import type { RequiredGeneric } from '@pba/react-utils';
import { Form, TextArea } from 'ui';

export type ExtendedRequestJoinFormValues = {
  reason?: string;
};

const RequestJoinFormContent = <T extends ExtendedRequestJoinFormValues = never>(_: RequiredGeneric<T>) => (
  <Form.Item<ExtendedRequestJoinFormValues>
    extra="Let us know why you want to join this community"
    label="Message"
    name="reason"
  >
    <TextArea />
  </Form.Item>
);

export default RequestJoinFormContent;
